import { render, staticRenderFns } from "./card-personal.vue?vue&type=template&id=22da9530&"
import script from "./card-personal.vue?vue&type=script&lang=js&"
export * from "./card-personal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports